import { USE_MOCKS } from '../config/serviceConfig';
import { orderMock } from './mock/order.mock';
import { orderReal } from './real/order.real';
import type { IOrderService } from './interfaces/IOrderService';

export const orderService: IOrderService = USE_MOCKS ? orderMock : orderReal;
